import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './store';
import ScrollToTop from './components/ScrollToTop';
import App from './containers/App';
import './utils/axiosConfigs';
import registerServiceWorker from './registerServiceWorker';
import './index.css';

const { PUBLIC_URL: publicURL } = process.env;

ReactDOM.render(
  <Provider store={store}>
    <Router basename={publicURL || '/'}>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </Router>
  </Provider>,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js